// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"283":"92337f3b","453":"1fdaf9dd","774":"22591c07"}[chunkId] + ".chunk.js");